import { render, staticRenderFns } from "./RightTips.vue?vue&type=template&id=78ad0412&scoped=true&"
import script from "./RightTips.vue?vue&type=script&lang=js&"
export * from "./RightTips.vue?vue&type=script&lang=js&"
import style0 from "./RightTips.vue?vue&type=style&index=0&id=78ad0412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad0412",
  null
  
)

export default component.exports